import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../../../appContext/AppContext';
import AutocompleteV2 from '../../../../../component/AutocompleteObjectV2';
import { IconMenu } from '../../../../../component/IconSvg';
import SelectTree from '../../../../../component/SelectTree';
import { TreeChiDinhDichVu } from '../../../../../phan-he-kham-benh/constants/KhamBenh';
import { LOAI_VAT_TU } from '../../../../../phan-he-kham-benh/constants/VatTu';
import { IKhoThuoc } from '../../../../../phan-he-kham-benh/models/ThuocModels';
import { getWarehouse } from '../../../../../phan-he-kham-benh/services/ThuocService';
import { getDanhSachLoaiVatTu } from '../../../../../phan-he-kham-benh/services/VatTuService';
import { CODE, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../../../utils/Constant';
import { getWarehouseProcess } from '../../../../../utils/ServicesUtils';
import { usePhanHeDieuTriNoiTruContext } from '../../../../PhanHeDieuTriContext';
import { getListVatTu } from '../../common';
import { useKeVatTuContext } from '../../context';

type Props = {
	donVatTuDetail: any;
	disableSelectKhoVatTu?: boolean;
};

const TreeVatTu = ({ donVatTuDetail, disableSelectKhoVatTu }: Props) => {
	const { setIsLoading } = useContext(AppContext);
	const { setTreeNodeValue, setTreeValue, treeValue, setSelectedNode } = useKeVatTuContext();
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();

	const [nodeIdSelected, setNodeIdSelected] = useState<string>('');
	const [treeData, setTreeData] = useState<any>(TreeChiDinhDichVu);
	const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
	const [danhSachTuVatTu, setDanhSachTuVatTu] = useState<IKhoThuoc[]>([]);

	useEffect(() => {
		getTuVatTu();
	}, []);

	useEffect(() => {
		if (treeValue?.id) {
			getLoaiVatTu();
			if (nodeIdSelected) {
				setNodeIdSelected('');
				setTreeNodeValue([]);
			}
		}
	}, [treeValue?.id]);

	useEffect(() => {
		let khoVatTuDefaultValue = danhSachTuVatTu.find(
			row => row.id === parseInt(donVatTuDetail?.warehouseId)
		);
		if (khoVatTuDefaultValue) {
			setTreeValue(khoVatTuDefaultValue);
		}
	}, [donVatTuDetail?.warehouseId, danhSachTuVatTu]);

	const getTuVatTu = async () => {
		try {
			let formCode = REQUEST_FROM.DIEU_TRI;
			let medicalItemTypeCode = REQUEST_TYPE.VAT_TU;
			const resWarehouseProcess = await getWarehouseProcess({
				formCode,
				medicalItemTypeCode,
				visitObjectTypeCode: benhNhanDieuTri?.visitObjectTypeCode,
			});
			if (resWarehouseProcess?.data) {
				const { data } = await getWarehouse({
					warehousePrescriptions: resWarehouseProcess?.data,
				});
	
				if (data) {
					setDanhSachTuVatTu(data.content);
				}
			} else {
				toast.error('Không tìm thấy cấu hình luồng kho');
				setDanhSachTuVatTu([]);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const getLoaiVatTu = async () => {
		try {
			const { code, data } = await getDanhSachLoaiVatTu();
			if (CODE.SUCCESS === code && data) {
				const dataConverted = {
					code: 'all',
					name: 'Kho vật tư',
					icon: <IconMenu />,
					filter: [
						{
							name: 'Tất cả vật tư',
							code: 'all-items',
							filter: data.content,
						},
					],
				};
				setTreeData(dataConverted);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onNodeSelected = async (data: any) => {
		try {
			setSelectedNode(data);
			
			if (!data) {
				setTreeNodeValue([]);
				return;
			};

			const result = await getListVatTu({
				materialType: data.code,
				warehouseId: treeValue.id,
				materialGroup: LOAI_VAT_TU.VAT_TU,
				pageIndex: 1,
				pageSize: 100,
			}, setIsLoading);
			
			setTreeNodeValue(result ?? []);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<div className="spaces px-12 py-5 h-42">
				<AutocompleteV2
					placeholder="Chọn kho vật tư"
					options={danhSachTuVatTu}
					name="tuVatTu"
					className="spaces mt-10"
					value={treeValue}
					onChange={selectedOption => {
						setTreeValue(selectedOption);
					}}
					isDisabled={disableSelectKhoVatTu}
				/>
			</div>
			<div>
				{treeValue?.id && treeData && (
					<SelectTree
						className="spaces top-15 w-100 py-2 ps-4 h-calc-vh-154 border border-top-0 overflow-auto"
						idSelected={nodeIdSelected}
						handleChangeSelectId={setNodeIdSelected}
						getSelectedItem={onNodeSelected}
						selectTree={treeData}
						codeCollapses={codeCollapses}
						handleChangeCollapsesCode={setCodeCollapses}
					/>
				)}
			</div>
		</>
	);
};

export default TreeVatTu;
